module.exports = __webpack_public_path__ + "static/media/investor.93db664d.png";